// extracted by mini-css-extract-plugin
export default {"Card":"DashboardCard_Card__HirWY","iconCard":"DashboardCard_iconCard__HYKDa"};